import React from 'react'
import PropTypes from 'prop-types'

import {
  PanesComponent as Panes,
  WebinarInfoPaneComponent,
  WebinarUserInfoPaneComponent,
} from '../../../sharedLegacy/components'
import {
  isExternalFeedConnectionType,
  useConnectInfoQuery,
} from '../../../global/blocs/useConnectInfo'
import { NoticesBanner } from '../../../Layout/Notices/NoticesBanner'
import { WebinarConnectionDetails } from '../WebinarAppComponent/WebinarConnectionDetails'

import './WebinarFoyerComponent.scss'

const getWebinarStatus = (isDraft, liveStatus, isBroadcasting) => {
  if (!isDraft && liveStatus === 'upcoming') {
    return 'upcoming'
  }

  if (!isDraft && liveStatus === 'live') {
    if (!isBroadcasting) {
      return 'upcoming'
    }

    return 'live'
  }

  return 'draft'
}

const FoyerPanes = {
  WebinarInfo: 0,
  UserInfo: 1,
}

/**
 * WebinarFoyerComponent
 */
const WebinarFoyerComponent = ({ renderOptions }) => {
  const { data: webinarConnectInfo } = useConnectInfoQuery()

  const numberOfPanes = Object.keys(FoyerPanes).length

  const status = getWebinarStatus(
    webinarConnectInfo?.draft_p,
    webinarConnectInfo?.live_status,
    webinarConnectInfo?.broadcasting_p
  )

  return (
    <div className="webinar-foyer">
      <NoticesBanner />
      <div className="webinar-foyer-panes">
        <Panes
          numberOfPanes={numberOfPanes}
          direction="row"
          renderPane={(index) => {
            if (index === FoyerPanes.WebinarInfo) {
              return (
                <WebinarInfoPaneComponent
                  title={webinarConnectInfo?.name ?? ''}
                  description={webinarConnectInfo?.description_html ?? ''}
                  status={status}
                  speakers={webinarConnectInfo?.speakers ?? []}
                  canDisableSpeakers
                />
              )
            }

            if (index === FoyerPanes.UserInfo) {
              const connectionType = webinarConnectInfo?.connection_type
              const isExternalStream =
                isExternalFeedConnectionType(connectionType)

              return (
                <WebinarUserInfoPaneComponent
                  name={webinarConnectInfo?.connect_name ?? ''}
                  avatarUrl={webinarConnectInfo?.connect_avatar_url ?? null}
                >
                  {isExternalStream && (
                    <WebinarConnectionDetails
                      streamingServerUrl={
                        webinarConnectInfo?.connection_details_url
                      }
                      streamKey={
                        webinarConnectInfo?.connection_details_stream_key
                      }
                      connectionType={connectionType}
                    />
                  )}
                  {webinarConnectInfo?.webrtc_role &&
                    renderOptions &&
                    renderOptions(
                      webinarConnectInfo.webrtc_role,
                      webinarConnectInfo.connect_presenter_link,
                      isExternalStream
                    )}
                </WebinarUserInfoPaneComponent>
              )
            }

            return null
          }}
        />
      </div>
    </div>
  )
}

WebinarFoyerComponent.propTypes = {
  renderOptions: PropTypes.func,
}

// eslint-disable-next-line import-x/no-default-export
export default WebinarFoyerComponent
